import { useState } from 'react';
import styled, { css } from 'styled-components';
import Modal from './Modal';
import AvatarUpload from './AvatarUpload';

const styles = css`
display: flex;
flex-wrap: wrap;
flex-direction: column;
width: 100%;
align-content: center;
text-align: center;
gap: 10px;

textarea: {
  resize: none;
}

& input {
  width: 75%;
}
.buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
`;

const EditItem = styled(({ className, item = null, title = '', onSave, onCancel }) => {
  const [description, setDescription] = useState(item?.description ?? '');
  const [price, setPrice] = useState(item?.price || '');
  const [url, setUrl] = useState(item?.url ?? '');
  const [image, setImage] = useState(item?.image ?? '');
  const isSubmitOk = (description !== '');

  const clear = () => {
    setDescription('');
    setPrice('');
    setUrl('');
    setImage('');
  }

  const cancel = () => {
    clear();
    onCancel();
  }

  const updateItem = () => {
    if (isSubmitOk) {
      const updatedItem = {
        description,
        price,
        image,
        url,
        source: 'internal',
      };
      if (item?._id) {
        updatedItem._id = item._id;
      }
      clear();
      onSave(updatedItem);
    }
  }

  return (
    <Modal isOpen={true}>
      <title>
        {title}
      </title>
      <main>
        <div className={className}>
          <textarea rows={4} placeholder='Description' value={description} onChange={e => setDescription(e.target.value)} />
          <input placeholder='Price' value={price} onChange={e => setPrice(e.target.value)} />
          <input placeholder='Product Link' value={url} onChange={e => setUrl(e.target.value)} />
          <AvatarUpload avatar = {image} onUploaded = {url => setImage(url)}/>
        </div>
      </main>
      <footer>
        <button className='danger' onClick={cancel}>Cancel</button>
        <button disabled={!isSubmitOk} className='primary' onClick={updateItem}>Save</button>
      </footer>
    </Modal>
  )
})`${styles}`;

export default EditItem;